import React from "react";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faChevronCircleDown,
  faCheck,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
// import styles from "../../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import LeaseListingTable from "./LeaseListingTable";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseListing extends React.Component {
  state = {
    redirect: false,
    brands: [],
    assets: [],
    statusCount: {},
    selectedBrand: "",
    selectedAsset: "",
  };

  constructor(props) {
    super(props);


  }
  componentDidMount() {
    this.loadBrands();
    this.loadAssets();
    
    fetch(`${apiUrl.apiUrl.url}/lease-view/get-status-count`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          statusCount: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  loadAssets = async () => {
    const response = await axios.get(`${apiUrl.apiUrl.url}/assets`);
    console.log(response);
    this.state.assets = response.data;
    this.setState({});
  };

  loadBrands = async () => {
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/brand/get-brands?page=1&per_page=100&delay=1`
    );
    this.state.brands = response.data.data;
    this.setState({});
  };
  render() {

    return (
      <div
        className="parentContainer"
        style={{
          float: "left",
          width: "75%",
          display: "block",
          overflowY: "auto",
          overflowX: "hidden",
          height: "100%",
          padding: "25px",
          border: "2px solid red"
        }}
      >
        <div>
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div className="viewLeaseSection">
        <div className="unitFormContainer viewLeaseForm">
          <div className="container">
            <div className="row">

              <div className="col-lg-4 offset-lg-2">
                <div className="inputContainer">
                  <select
                    onChange={(e) => {
                      this.setState({ selectedAsset: e.target.value });
                    }}
                  >
                    <option value="">Select Asset</option>
                    {this.state.assets.map((x) => (
                      <option key={x.id} value={x.id}>
                        {x.asset_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="inputContainer">
                  <select
                    onChange={(e) => {
                      this.setState({ selectedBrand: e.target.value });
                    }}
                  >
                    <option value="">Select Brand</option>
                    {this.state.brands.map((x) => (
                      <option key={x.brandId} value={x.brandId}>
                        {x.brandName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="container cards">
            <div className="row">
              <div className="col">
                <div className="viewLeaseCards">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faSearch} />
                    </span>
                    Prospect
                  </h1>
                  <h2>{this.state.statusCount.prospect}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards darkBlue">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faChevronCircleDown} />
                    </span>
                    Dropped
                  </h1>
                  <h2>{this.state.statusCount.dropped}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards lightOrange">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faFileSignature} />
                    </span>
                    Draft
                  </h1>
                  <h2>{this.state.statusCount.draft}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards pink">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faCheck} />
                    </span>
                    Approval
                  </h1>
                  <h2>{this.state.statusCount.approval}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards lightGreen">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faCheckCircle} />
                    </span>
                    Active
                  </h1>
                  <h2>{this.state.statusCount.active}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards purple">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faExclamationTriangle} />
                    </span>
                    Expired
                  </h1>
                  <h2>{this.state.statusCount.expired}</h2>
                </div>
              </div>
              <div className="col">
                <div className="viewLeaseCards red">
                  <h1>
                    <span className="iconHolder">
                      <FontAwesomeIcon icon={faTimesCircle} />
                    </span>
                    Terminated
                  </h1>
                  <h2>{this.state.statusCount.terminated}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LeaseListingTable
          key={this.state.selectedBrand + "--" + this.state.selectedAsset}
          asset={this.state.selectedAsset}
          brand={this.state.selectedBrand}
        />
      </div>
    );
  }
}

export default withRouter(LeaseListing);
